import {useState, useEffect} from 'react'
import './forms.css'
import {auth} from './firebase'
import {useNavigate, Link} from 'react-router-dom'
import {createUserWithEmailAndPassword} from 'firebase/auth'
import { db } from './firebase'
import {
  collection,
  getDocs,
  //getDoc,
  Timestamp,
  doc,
  addDoc,
 // setDoc,
 // updateDoc,
  //deleteDoc,
  
} from "firebase/firestore";
import logoImg1 from './assets/logoG.png';
import InputMask from 'react-input-mask';
 

//import {useAuthValue} from './AuthContext'


function Register() {

  const [email, setEmail] = useState('')
  const [nomecompl, setNomecompl] = useState('')
  const [cpf, setCPF] = useState('')
  const [telefone, setTelefone] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [grupos, setGrupos] = useState([])  
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  
  
  const bookCollectionRef = collection(db, "usuarios");
  const groupsCollectionRef = collection(db, "grupoparcerias");

 /* const optionsGrupos = [
    { label: 'selecione...', value: 'selecione...' },
    { label: 'Cond. Caribe Residence Resort / Palmas-TO', value: 'Cond. Caribe Residence Resort' },
    { label: 'Cond. Palmeira Dourada / Palmas-TO', value: 'Cond. Palmeira Dourada' },
    { label: 'Cond. Palmeira Real / Palmas - TO', value: 'Cond. Palmeira Real' },
    { label: 'Cond. Residencial Classic / Palmas - TO', value: 'Cond. Residencial Classic' },
    { label: 'Cond. Smart Residence / Palmas - TO', value: 'Cond. Smart Residence' },
    { label: 'Cond. Cotovia / Palmas - TO', value: 'Cond. Cotovia' },
    { label: 'Residencial Pantanal / Palmas - TO', value: 'Pantanal704' },
    { label: 'Cond. Palmeira Imperial / Palmas - TO', value: 'Cond. Palmeira Imperial' },
    { label: 'Cond. Residencial Bella Villa / Palmas - TO', value: 'Cond. Res. Bella Villa' },
    { label: 'Cond. Polinésia Residence / Palmas - TO', value: 'Cond. Res. Polinésia' }
  ]; */

  const [valuegrup, setValuegrup] = useState('selecione...');

  const handleChange = (event) => {
    setValuegrup(event.target.value);
  };

  const sendWhatsReg = (nomecomp, emailusr)  => {
    
    // Send data to the backend via POST
    fetch('https://api.callmebot.com/whatsapp.php?phone=556392150988&text=O+usuario+' +nomecomp+'+||+'+emailusr+'+acabou+de+criar+uma+conta+no+Topago+Cashback+pelo+site&apikey=9548891', {  // Enter your IP address here

      method: 'POST', 
      mode: 'cors', 
     //body: JSON.stringify(jsonData) // body data type must match "Content-Type" header

    })
    
  }

  const validatePassword = () => {
    let isValid = true
    if (password !== '' && confirmPassword !== ''){
      if (password !== confirmPassword) {
        isValid = false
        setError('Passwords does not match')
      }
    }
    return isValid
  }

 

  const register = e => {
    e.preventDefault()
    setError('')
    if(validatePassword()) {
     
        createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          let user = userCredential.user;
         // const docRef = doc(db, bookCollectionRef, user.uid);
         /* return updateDoc(docRef, {
            codigoIndica: null,
            nomeUser: nomecompl,
            documUser: cpf,
            prestserv: false,
            foneUser:telefone,
            grupoparceiro: valuegrup,
            emailUser: email,
            platformuser: 'windows/web',
            //dataCadastro:  Math.floor(Date.now()/1000),
            dataCadastro:  Timestamp.fromDate(new Date()),
            userFire: user.uid
          }) */
          return addDoc(bookCollectionRef, {
              codigoIndica: null,
              nomeUser: nomecompl,
              documUser: cpf,
              foneUser:telefone,
              grupoparceiro: valuegrup,
              prestserv: false,
              emailUser: email,
              platformuser: 'windows/web',
              //dataCadastro:  Math.floor(Date.now()/1000),
              dataCadastro:  Timestamp.fromDate(new Date()),
              userFire: user.uid
            })  
          .catch((err) => alert(err.message))
        }) 
        .catch(err => setError(err.message))
        navigate('/verify-email')
       
    }
    sendWhatsReg(nomecompl,email)
    setEmail('')
    setPassword('')
    setConfirmPassword('')
  } 

  const getGrupos = async () => {
    const data = await getDocs(groupsCollectionRef)
    //loop through documents in collection
    setGrupos(
        data.docs.map((doc) => ({ ...doc.data(), key: doc.id }))
    )
    if (loading) {
      setLoading(false);
    }
  }

  useEffect(() => {
           
    getGrupos();
     //console.log("li tudo")
  }, [loading]) 

  return (
    <div className='center'>
      <div className='auth'>
      <img src={logoImg1} width="150" height="150"/>
        <h1>Criar Novo Usuário</h1>
        <h3>ToPago Cashback</h3>
        {error && <div className='auth__error'>{error}</div>}
        <form onSubmit={register} name='registration_form'>
        <input 
            type='text' 
            value={nomecompl}
            placeholder="Informe seu nome"
            required
            onChange={e => setNomecompl(e.target.value)}/>

       {/* <input 
            type='text' 
            value={cpf}
            maxLength='14'
            placeholder="Informe seu CPF"
            required
            onChange={e => setCPF(e.target.value)}/> */}
        <InputMask
              mask='999.999.999-99'
              placeholder='Informe seu CPF'
              value={cpf}
              required
              onChange={e => setCPF(e.target.value)} />
        
      { /* <input 
            type='text' 
            value={telefone}
            placeholder="Informe seu Telefone"
            required
            onChange={e => setTelefone(e.target.value)}/>
          */}  
        <InputMask
              mask='(99) 99999-9999'
              placeholder='Informe seu telefone'
              value={telefone}
              required
              onChange={e => setTelefone(e.target.value)} />
            

          <input 
            type='email' 
            value={email}
            placeholder="Informe seu email"
            required
            onChange={e => setEmail(e.target.value)}/>

          <input 
            type='password'
            value={password} 
            required
            placeholder='Informe a senha'
            onChange={e => setPassword(e.target.value)}/>

            <input 
            type='password'
            value={confirmPassword} 
            required
            placeholder='Confirme a senha'
            onChange={e => setConfirmPassword(e.target.value)}/>

            
            <select value={valuegrup} onChange={handleChange}>
            <option value="0">Informe seu grupo...</option>
                {grupos.map((option, index) => (
                <option value={option.label} key={index}>{option.label}</option>
              ))}
            </select>
             
          <button type='submit'>Registrar</button>
        </form>
        <span>
          Já tem uma conta?   
           - <Link to='/login'>Login</Link>
        </span>
      </div>
    </div>
  )
}

export default Register
